import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileCoupons from "components/profileCoupons/ProfileCoupons/ProfileCoupons";

interface Props {}

const ProfilePage = (props: Props) => {
  return (
    <>
      <Head>
        <title>
          Noe Sushi Bar Quito, Guayaquil y Cuenca | Cupones y promos
        </title>
        <meta
          name="description"
          content="Aprovecha los mejores descuentos y promociones en Noe Sushi Bar. Cupones exclusivos para nuestros clientes en Quito, Guayaquil y Cuenca."
        />
        <meta name="keywords" content="Noe Cupones y promos" />
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <ProfileCoupons />
      </TabsMenu>
    </>
  );
};

export default ProfilePage;
